import React from 'react';
import Popup from 'reactjs-popup';
import uuid from 'uuid4';

import classes from './Button.module.scss';
import Spinner from 'Flow2/components/UI/Spinner/Spinner';

const button = (props) => {
    if(props.href) {
        return(
            <a type="button"
            disabled={props.disabled || props.spinner}
            className={[classes.Button, classes[props.btnType], props.additionalClass].join(' ')}
            href={props.href}
            target={props.target}
            download={props.download}
            title={props.title}
            >
            {props.icon && !props.spinner ? <span><img alt='' src={props.icon}/></span>:null}
            {props.spinner ? <Spinner type="spinner-small"/>: null}
            {props.children}
            </a>
        );
    } else if(props.menu) {
        return(
            <Popup trigger={<button
                    title={props.title}
                    disabled={props.disabled}
                    className={[classes.Button, classes[props.btnType], props.additionalClass].join(' ')}>
                    {props.icon ? <span><img alt='' src={props.icon}/></span>:null}
                    {props.children}
                    </button>} 
                position="bottom right"    
                on="click" 
                contentStyle={{width: '300px'}}
                closeOnDocumentClick 
                mouseLeaveDelay={300}>
                    {close => (
                    <div className={classes.Menu}>
                    {
                        props.disabled ?
                            <div className={classes.Menu_Item}>Bitte warten</div>
                        : props.menu.map(element => {
                            // ** TF: CHANGED THE NAME OF THE CLICK HANDLER ** //
                            //return(<div key={uuid()} className={classes.Menu_Item} clicked={() => { element.callback(); close(); }}>{element.text}</div>);
                            return(<div key={uuid()} className={classes.Menu_Item} onClick={() => { element.callback(); close(); }}>{element.text}</div>);
                        })
                    }
                    </div>
                    )}
            </Popup>
        );
    }

    return(
        <button
        disabled={props.disabled || props.spinner}
        className={[classes.Button, classes[props.btnType], props.additionalClass].join(' ')}
        onClick={props.clicked}
        title={props.title}
        >
        {props.icon && !props.spinner ? <span><img alt='' src={props.icon}/></span>:null}
        {props.spinner ? <Spinner type="spinner-small"/>: null}
        {props.children}
        </button>
    );    
};

export default button;
